import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=4425c2a2&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"
import style0 from "./Payment.vue?vue&type=style&index=0&id=4425c2a2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4425c2a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4425c2a2')) {
      api.createRecord('4425c2a2', component.options)
    } else {
      api.reload('4425c2a2', component.options)
    }
    module.hot.accept("./Payment.vue?vue&type=template&id=4425c2a2&scoped=true", function () {
      api.rerender('4425c2a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/tabs/Payment.vue"
export default component.exports